/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

import {Component, Input, OnInit, inject} from '@angular/core';
import {InteractionItem} from '../../../../models/InteractionHistory';
import {PassportService} from '../../../../services/passport.service';
import {PassportDto} from '../../../../models/Passport';

const MINUTES_TO_GROUP = 10;

@Component({
  selector: 'app-battery-interaction-history',
  templateUrl: './battery-interaction-history.component.html',
  styleUrl: './battery-interaction-history.component.scss',
  standalone: false,
})
export class BatteryInteractionHistoryComponent implements OnInit {
  private readonly passportService = inject(PassportService);

  @Input() passport?: PassportDto;

  loading = true;
  mappedInteractionHistory: InteractionItem[] = [];
  interactionHistory: InteractionItem[] = [];

  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.interactionHistory = await this.passportService.interactionHistory(
      this.passport?.id ?? '',
    );
    this.mappedInteractionHistory = this.groupInteractions(
      this.interactionHistory,
    );
    this.loading = false;
  }

  groupInteractions(interactionItems: InteractionItem[]): InteractionItem[] {
    if (interactionItems.length > 0) {
      interactionItems = interactionItems.sort(
        (a, b) =>
          new Date(b.modifiedAt).getTime() - new Date(a.modifiedAt).getTime(),
      );
      const groupInteractions: InteractionItem[] = [interactionItems[0]];
      interactionItems.forEach((item) => {
        const oldItem = groupInteractions.at(-1);
        let prevDate = new Date();
        if (oldItem) {
          prevDate = new Date(oldItem.modifiedAt);
        }
        prevDate.setMinutes(prevDate.getMinutes() - MINUTES_TO_GROUP);
        if (
          prevDate > new Date(item.modifiedAt) ||
          oldItem?.modifiedBy !== item.modifiedBy
        ) {
          item.toEventId = item.eventId;
          groupInteractions.push(item);
        } else {
          oldItem.toEventId = item.eventId;
        }
      });

      interactionItems = groupInteractions;
    }
    return interactionItems;
  }
}
